export default __webpack_public_path__ + "static/media/warningIcon.a117f659.svg";